import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  id: null,
  firstName: "User",
  lastName: "Admin",
  phoneNumber: null,
  email: null,
  status: null,
  createdAt: null,
  updatedAt: null,
  deletedAt: null,
  code: null,
  sex: null,
  birthDay: null,
  address: null,
  carrier: null,
  roles: [],
};

const userSlice = createSlice({
  name: "user",
  initialState,
  reducers: {
    setUser: (state, action) => {
      return { ...state, ...action.payload };
    },
    resetUser: () => initialState,
  },
});

export const { setUser, resetUser } = userSlice.actions;

export default userSlice.reducer;
